import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchHomeData } from "./homeAPI";
export interface UserState {
  userData: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: UserState = {
  userData: {},
  status: "idle",
};

export const GetUserData = createAsyncThunk("user/fetchHomeData", async (id:any) => {
  const response = await fetchHomeData(id);
  return response;
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUserData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUserData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetUserData.fulfilled, (state, action) => {
        state.status = "success";
        state.userData = action.payload.user;
      });
  },
});

export const {} = userSlice.actions;

export const selectUserData = (state: RootState) => {
  return state.user.userData;
};

export default userSlice.reducer;
